// import 'jquery';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/button';
import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import hamburger from "./hamburger";
import smoothScroll from "./smoothScroll";
import carousel from "./carousel";
import dropdown from "./dropdown";
import faq from "./faq";
import preloader from "./preloader";
import {JumpLinks} from "./JumpLinks";

hamburger();
smoothScroll();
carousel();
dropdown();
faq()
preloader();
const jumpLinks = new JumpLinks();
jumpLinks.run()
